import { Component, input } from '@angular/core';

@Component({
  selector: 'cfp-login-loading-spinner',
  templateUrl: './login-loading-spinner.html'
})
export class LoginLoadingSpinner {
  protected readonly loading = input<boolean>();
}
